import { Fragment, useState, useEffect } from 'react'

// third party components
import { Dialog, Transition } from '@headlessui/react'

// styles
import styles from './index.module.scss'

import CollectionCardMenuPage from 'components/Menu/CollectionCardMenuPage'

export interface CollectionCardMenuModalProps<T> {
  open: boolean
  onClose: () => void
  shareCollection: any
  unSave: any
  isOwn: boolean
  isFavorite: boolean
}

const CollectionCardMenuModal = <T,>({
  open,
  onClose,
  shareCollection,
  unSave,
  isOwn,
  isFavorite = false,
}: CollectionCardMenuModalProps<T>) => {
  const closeModal = () => {
    onClose()
  }

  const [show, setShow] = useState(false)

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setShow(true)
      }, 100)
    }
  }, [open])

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className={styles.container} onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={styles.bgView} />
        </Transition.Child>
        <div className="fixed inset-0" onClick={() => closeModal()}>
          <div className={`${styles.modalView} ${show ? styles.show : styles.hide}`}>
            <div className="w-full h-full">
              <CollectionCardMenuPage
                shareCollection={shareCollection}
                unSave={unSave}
                isOwn={isOwn}
                isFavorite={isFavorite}
              />
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default CollectionCardMenuModal
